<template>
  <div id="tugendhat">
    <app-navbar></app-navbar>
    <div class="red-block"></div>
    <div class="whiteBalls">
      <img class="img-fluid" src="@/assets/designelements/whiteBalls.png" alt="whiteBalls">
    </div>
    <div class="crossBallone">
      <img class="img-fluid" src="@/assets/designelements/crossRedDigon.png" alt="crossBallone">
    </div>
    <div class="redBallone">
      <img class="img-fluid" src="@/assets/designelements/redBallone.png" alt="redBallone">
    </div>
    <div class="container page-block paddingBottom">
      <div class="col-lg-8 offset-lg-2 crop-img">
        <img
          class="img-fluid img-top gallery-picture"
          v-if="mainImageUrl"
          v-on:click="$refs.galleryModal.show(mainImageUrl)"
          :src="mainImageUrl"
          @error="hasMainImage = false"
          alt="Light Up Tugendhat"
        >
      </div>
      <div class="col-lg-8 offset-lg-2 white-box pt-lg-4">
        <h2>{{ page.title | translation }}</h2>
        <div v-html="html" class="editor-content textContent pb-lg-4 text-justify"></div>
      </div>
      <div class="col-lg-8 offset-lg-2 withOutPadding" v-if="images.length > 0">
        <div class="row no-gutters">
          <div class="col-lg-4 withOutPadding" v-for="image in images" v-bind:key="image">
            <img class="img-fluid gallery-picture" v-on:click="$refs.galleryModal.show(image)" :src="image" alt="Light Up Tugendhat">
          </div>
        </div>
      </div>
      <gallery-modal ref="galleryModal"/>
    </div>
    <app-footer class="tugendhat-footer"></app-footer>
  </div>
</template>

<script>
import navbar from "@/components/base/navbar";
import axios from "@/api/axiom-instance";
import config from "@/config";
import footer from "@/components/base/footer";
import GalleryModal from "@/components/base/GalleryModal";

export default {
  name: "Tugendhat",
  components: {
    'app-navbar': navbar,
    'app-footer': footer,
    'gallery-modal': GalleryModal
  },
  computed: {
    html: function () {
      const text = this.$options.filters.translation(this.page.text)
      return text != null ? text : ''
    },
    mainImageUrl: function () {
      return this.hasMainImage ? (config.API_URL + '/image?type=tugendhat-main&name=tugendhat') : null
    }
  },
  data() {
    return {
      page: { title: {}, text: {}, visible: false },
      hasMainImage: false,
      images: []
    }
  },
  created() {
    this.load()
  },
  methods: {
    load: function () {
      axios
        .get("/tugendhat")
        .then((success) => {
          if (success.data) {
            this.page = success.data
            this.hasMainImage = true
          } else {
            this.$router.replace("/")
          }
        })
        .catch(() => {
          this.$router.replace("/")
        })
      axios
        .get("/image/list", { params: { type: "tugendhat-others/tugendhat" } })
        .then((success) => {
          this.images = success.data.map(it => (config.API_URL + '/image?type=' + it.type + '&name=' + it.name))
        })
    }
  }
}
</script>

<style scoped>
h2 {
  color: #0f2328;
  font-size: 2.5em;
  font-family: "Transcript Pro";
}

.crop-img {
  padding: 0 0;
  overflow: hidden;
  height: auto;
}

.img-top {
  width: 100%;
  cursor: pointer;
}

.withOutPadding {
  padding: 0 0;
}

.textContent {
  font-family: "Transcript Mono";
  color: #152326;
  padding-top: 1em;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.paddingBottom {
  padding-bottom: 10em;
}

.page-block {
  padding-top: 20em;
  position: relative;
  z-index: 1;
  flex: 1 0 auto;
  width: 100%;
}

.white-box {
  background-color: #eae7d6;
}

.crossBallone {
  width: 10%;
  position: absolute;
  top: 70vh;
  text-align: end;
  right: 7%;
  z-index: 0;
  pointer-events: none;
}

.red-block {
  position: absolute;
  background-color: #ED5B2D;
  top: 105vh;
  width: 70%;
  z-index: 0;
  bottom: 0;
  pointer-events: none;
}

.redBallone {
  position: absolute;
  width: 20%;
  top: 23vh;
  left: 15%;
  z-index: 0;
  pointer-events: none;
}

.whiteBalls {
  position: absolute;
  width: 6%;
  top: 92vh;
  left: 7%;
  z-index: 0;
  pointer-events: none;
}

#tugendhat {
  background-color: #FFCE6D;
  min-height: 100vh;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

.tugendhat-footer {
  position: relative;
  flex-shrink: 0;
  z-index: 2;
}

.gallery-picture {
  cursor: pointer;
}

@media screen and (max-width: 991px) {
  .page-block {
    padding-top: 6rem;
  }

  h2 {
    padding-top: 1.5rem;
  }
}
</style>
